'use client'

import { isbot } from 'isbot'

import useCookiesConsent from '@hooks/useCookiesConsent'
import { useEffect } from 'react'

const SCRIPT_ID = 'apollo_tracker'

// Apollo's loader exactly as supplied for S20-1116 (Jira comment 42312), minus the <script> wrapper that is
// only needed when pasting HTML. Do not tidy it: the account's appId and the nocache query are part of it.
const APOLLO_LOADER = `function initApollo(){var n=Math.random().toString(36).substring(7),o=document.createElement("script");
o.src="https://assets.apollo.io/micro/website-tracker/tracker.iife.js?nocache="+n,o.async=!0,o.defer=!0,
o.onload=function(){window.trackingFunctions.onLoad({appId:"6abd280a4089d400202d2790"})},
document.head.appendChild(o)}initApollo();`

export default function ApolloTracker({ isProd }: { isProd: boolean }): null {
  const [areCookiesAccepted] = useCookiesConsent()

  useEffect(() => {
    if (!areCookiesAccepted || !isProd) {
      return
    }
    // Our own smoke suite accepts cookies in its beforeEach, and JS-running crawlers can carry consent.
    // Bot visits would pollute the company-level visitor list.
    if (isbot(navigator.userAgent)) {
      return
    }
    // StrictMode runs this effect twice in dev, and a prop change re-runs it in prod.
    if (document.getElementById(SCRIPT_ID)) {
      return
    }
    const script = document.createElement('script')
    script.id = SCRIPT_ID
    script.innerHTML = APOLLO_LOADER
    document.head.appendChild(script)
  }, [areCookiesAccepted, isProd])

  return null
}
